import React from "react";
import { Avatar, SvgIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import PropTypes from "prop-types";
import { useTheme } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import { validateOrderShopTypes } from "../../constants";

const iconPaths = {
  location:
    "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z",
  email:
    "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
  phone:
    "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
  store:
    "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z",
  videoCam:
    "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z",
  computer:
    "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z",
  directionsWalk:
    "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7",
  star:
    "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
  position:
    "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
  group:
    "M12,12.75c1.63,0,3.07,0.39,4.24,0.9c1.08,0.48,1.76,1.56,1.76,2.73L18,18H6l0-1.61c0-1.18,0.68-2.26,1.76-2.73 C8.93,13.14,10.37,12.75,12,12.75z M4,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C2,12.1,2.9,13,4,13z M5.13,14.1 C4.76,14.04,4.39,14,4,14c-0.99,0-1.93,0.21-2.78,0.58C0.48,14.9,0,15.62,0,16.43V18l4.5,0v-1.61C4.5,15.56,4.73,14.78,5.13,14.1z M20,13c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C18,12.1,18.9,13,20,13z M24,16.43c0-0.81-0.48-1.53-1.22-1.85 C21.93,14.21,20.99,14,20,14c-0.39,0-0.76,0.04-1.13,0.1c0.4,0.68,0.63,1.46,0.63,2.29V18l4.5,0V16.43z M12,6c1.66,0,3,1.34,3,3 c0,1.66-1.34,3-3,3s-3-1.34-3-3C9,7.34,10.34,6,12,6z"
};

function getIconPath(iconType, defaultIcon) {
  const type = iconType.toLowerCase();
  switch (type) {
    case validateOrderShopTypes.internet.toLowerCase():
      return iconPaths.email;
    case validateOrderShopTypes.phoneRecodered.toLowerCase():
    case validateOrderShopTypes.phoneNonRecorded.toLowerCase():
      return iconPaths.phone;
    case validateOrderShopTypes.onsiteRecordedAudio.toLowerCase():
    case validateOrderShopTypes.onsiteNonRecordedAudio.toLowerCase():
      return iconPaths.store;
    case validateOrderShopTypes.videoShop.toLowerCase():
    case validateOrderShopTypes.video.toLowerCase():
      return iconPaths.videoCam;
    case validateOrderShopTypes.virtualShopAudioRecorded.toLowerCase():
    case validateOrderShopTypes.virtualShopAudioVideoRecorded.toLowerCase():
      return iconPaths.computer;
    case validateOrderShopTypes.selfGuidedTourAudioRecorded.toLowerCase():
    case validateOrderShopTypes.selfGuidedTourAudioVideoRecorded.toLowerCase():
    case validateOrderShopTypes.selfGuidedTourNonRecorded.toLowerCase():
      return iconPaths.directionsWalk;
    case "location":
      return iconPaths.location;
    case "position":
      return iconPaths.position;
    case "group":
      return iconPaths.group;
    default:
      return !!defaultIcon ? iconPaths[defaultIcon] : iconPaths.star;
  }
}
const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.light,
    height: ({ size }) => size,
    width: ({ size }) => size
  },
  icon: {
    height: ({ iconSize }) => iconSize,
    width: ({ iconSize }) => iconSize
  }
}));

const GenericAvatar = props => {
  const { iconSize, size, icon, defaultIcon } = props;
  const classes = useStyles({ size, iconSize });
  const theme = useTheme();

  return (
    <>
      <Avatar className={classes.avatar}>
        <SvgIcon viewBox="0 0 24 24" className={classes.icon}>
          <defs>
            <linearGradient
              id="avatarGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              <stop
                offset="0%"
                stopColor={alpha(theme.palette.primary.main, 0.7)}
                stopOpacity={1}
              />
              <stop
                offset="100%"
                stopColor={theme.palette.primary.dark}
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <path
            id="path0"
            d={getIconPath(icon, defaultIcon)}
            stroke="none"
            fill="url(#avatarGradient)"
          ></path>
        </SvgIcon>
      </Avatar>
    </>
  );
};

export default GenericAvatar;

GenericAvatar.propTypes = {
  iconSize: PropTypes.number,
  /**
   * The background height/width
   */
  size: PropTypes.number,
  icon: PropTypes.string,
  defaultIcon: PropTypes.string
};

GenericAvatar.defaultProps = {
  size: 124,
  iconSize: 82
};
